import { clsx } from 'clsx';
import { FC, ReactNode } from 'react';

import Stack from '@o2/ui/Stack';

import { useSubheaderUtilityClasses } from './subheaderClasses';

interface HeadLeftProps {
  children: ReactNode;
}

const HeadLeft: FC<HeadLeftProps> = (props) => {
  const utilityClasses = useSubheaderUtilityClasses();

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      order={1}
      flexGrow={1}
      flexWrap="wrap"
      maxWidth="100%"
      spacing={{ xs: 0.5, md: 4 }}
      className={clsx(utilityClasses.left)}
      {...props}
    />
  );
};

HeadLeft.displayName = 'Subheader.HeadLeft';

export default HeadLeft;
